module.exports = __webpack_public_path__ + "static/media/3.a37934f9.jpg";